<template>
    <b-overlay rounded="sm">

        <!-- Abdullah responive added mx-3  -->
        <div class="row no-gutters py-2 mb-3 ml-3 custom-mobile-left-side-alignment-margin">
            <div class="col-md-10 col-sm-12" >
                <h4 class="atlhr-dashboard-title mt-10">
                Company <span class="black-title">Directory</span>
                <span>
                    <a v-bind:href="$api_url">Dashboard</a>
                    / Company Directory
                </span>
            </h4>
            </div>
        </div>
        <!-- Abdullah responive added mx-3  -->
        <b-overlay :show="showoverlay" rounded="sm" class="ml-3 custom-mobile-left-side-alignment-margin">

            <div class="card mt-0 border-0 bg-wash no-shadow company-directory table-sorting-icons">
                <common-list  :is_company_directory="is_company_directory" :all_employee="all_employee" :appended_column="appended_column" :company_options="company_options" :employees="employees" :default_column="default_column" :key="flg_key" :is_directory="is_directory"></common-list>
            </div>
        </b-overlay>

    </b-overlay>
</template>


<script>
export default{
        props: [],

        data(){

            return {
                all_employee:'yes',
                is_directory:1,
                employees : [],
                company_options:[],
                default_column:['name','employee_code','phone','email','jobposition','department','branch','blood_group'],
                notice: "Looks like you have not added any employee yet.",
                is_company_directory: 'yes',
                appended_column:[],
                flg_key:0,
            }
        },
        methods:{

            getEmployees: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                axios.get(this.$api_url+'/front/company/directory' , {

                    }).then(function(response){

                        this.showoverlay = false;
                        if(response.data.error == 1)
                            this.notice = response.data.notice;
                        else
                        {
                            this.employees = response.data.employee_data;
                            this.company_options = response.data.options;
                            this.flg_key +=1;

                        }

                        }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
        },
        created: function(){
            this.getEmployees();

        }
    }
</script>

<style>
.trz_people_btn{
	right: 0;
	top: -55px !important;
}
</style>
